import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import promise from 'redux-promise';
import { createBrowserHistory } from 'history';
import allReducers from '../reducers'; // This imports the rootReducer object containing all individual reducers

// Set up redux-first-history context
const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({
  history: createBrowserHistory(),
});

// Combine all reducers (spread the imported reducers object and add router)
const rootReducer = {
  ...allReducers, // Spread the rootReducer object to get all individual reducers
  router: routerReducer, // Add the router reducer
};

// Configure custom middleware (thunk is included by default in Redux Toolkit)
const customMiddleware = [promise, routerMiddleware];

// Use configureStore from @reduxjs/toolkit
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(customMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Expose redux history for use in React Router
export const reduxHistory = createReduxHistory(store);

export default store;
